import { render, staticRenderFns } from "./taskUploadingModal.vue?vue&type=template&id=64a0b3d4&scoped=true"
import script from "./taskUploadingModal.vue?vue&type=script&lang=js"
export * from "./taskUploadingModal.vue?vue&type=script&lang=js"
import style0 from "./taskUploadingModal.vue?vue&type=style&index=0&id=64a0b3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0b3d4",
  null
  
)

export default component.exports